import { render, staticRenderFns } from "./IntroPage.vue?vue&type=template&id=69896099&scoped=true"
import script from "./IntroPage.vue?vue&type=script&lang=js"
export * from "./IntroPage.vue?vue&type=script&lang=js"
import style0 from "./IntroPage.vue?vue&type=style&index=0&id=69896099&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69896099",
  null
  
)

export default component.exports